<template>
  <ag-grid-vue
    data-cy="metadata-grid"
    style="width: 100%; height: 70vh"
    :modules="agGridMixin.agModules"
    :class="uiStore.state.isDark ? 'ag-theme-balham-dark' : 'ag-theme-balham'"
    :default-col-def="defaultColDef"
    :column-defs="columnDefs"
    :row-data="rowData"
    :animate-rows="true"
    :master-detail="true"
    :row-group-panel-show="'always'"
    :enable-cell-text-selection="false"
    :enable-browser-tooltips="true"
    :suppress-copy-rows-to-clipboard="true"
    :suppress-row-click-selection="true"
    :pivot-panel-show="'always'"
    :enable-range-selection="true"
    :enable-charts="true"
    @grid-ready="(params) => agGridMixin.onGridReady(params, 'metadata')"
  />
</template>

<script setup>
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue3'
import defaultColDef from '@/mixins/globalDefaultColDef'
import { computed } from 'vue'
import useDocumentStore from '@/store/modules/document'
import useAgGridMixin from '@/mixins/agGridMixin.js'
import useUiStore from '@/store/modules/ui'

const uiStore = useUiStore()
const agGridMixin = useAgGridMixin()
const documentStore = useDocumentStore()

const columnDefs = [
  {
    headerName: 'Key',
    field: 'key',
    width: 150,
    filter: 'agSetColumnFilter',
    filterParams: { selectAllOnMiniFilter: true },
    hide: false,
  },
  {
    headerName: 'Value',
    field: 'value',
    filter: 'agTextColumnFilter',
  },
]

const rowData = computed(() => {
  const arr = []

  for (let item of documentStore.documentModels) {
    _.forEach(item.metadata, (key, value) => {
      arr.push({ key: value, value: key })
    })
  }
  return arr
})
</script>
